<template>
  <div class="phone-container">
    <div class="content" v-if="!phone">
      请绑定您本人名下的手机号码，您的学号是
      <span class="text-danger">{{ studentNo }}</span>
      。为确认操作，请完成以下验证
      <div class="line margin-top-10 margin-bottom-30"></div>
      <div class="margin-top-20 margin-bottom-20">
        <div class="row">
          <div class="col-md-2">请输入您的绑定手机</div>
          <div class="col-md-4">
            <input
              type="text"
              class="form-control"
              v-model="phoneNumber"
              @input="inputChange"
              style="width: 300px"
            />
            <div v-if="phoneError" class="tips margin-top-10">
              ({{ phoneError }})
            </div>
          </div>
          <div class="col-md-3">
            <div class="margin-left-30">
            <button
              class="verification"
              :disabled="smsDisabled"
              @click="verificationImage()"
            >
              {{ smsMessage }}
            </button>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-2">请输入短信验证码</div>
          <div class="col-md-9">
            <input
              type="text"
              class="form-control"
              v-model="code"
              style="width: 300px"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-md-2"></div>
          <div class="col-md-9">
            <button class="btn btn-confirm" @click="bindPhone">确定</button>
          </div>
        </div>
      </div>
      <div class="explain">
        <span>没收到短信验证码？</span><br />
        <span>1、网络通讯异常可能会造成短信丢失，请重新获取或稍后再试。</span
        ><br />
        <span>2、请核实手机是否已欠费停机，或者屏蔽了系统短信。</span><br />
        <span>3、如果手机已丢失或停用， 请选择其他验证方式 。</span><br />
        <span>4、您也可以尝试将SIM卡移动到另一部手机，然后重试。</span><br />
      </div>
      <a-modal
        :title="`图形验证码`"
        :visible="showFlag"
        @cancel="handleCancel"
        :footer="null"
        :width="300"
      >
        <div class="image-random">
          <input
            type="text"
            placeholder="请输入图形验证码"
            class="form-control"
            style="width: 150px"
            v-model="captcha"
          />
          <img v-if="imageCode" @click="getRandomImage" :src="imageCode" />
        </div>
        <div class="image-btn">
          <a-button type="primary" style="width: 100%" @click="sendSms"
          >确定</a-button
          >
        </div>
      </a-modal>
    </div>
    <div style="padding: 40px 20px" v-else>
      <span
      >您已绑定手机号{{
          phone.substr(0, 3) + "****" + phone.substr(7)
        }}，</span
      >
      <span>如需解绑或更换手机号，请联系辅导老师解绑后重新登录即可</span><br />
    </div>
  </div>
</template>

<script>
  import {mapMutations} from "vuex";

  export default {
    name: "PhoneCheck",
    /*props: {
      studentNo: {
        type: String,
      },
      phone: {
        type: String,
      },
    },*/
    data: function () {
      return {
        phoneError: "",
        showFlag: false,
        phoneNumber: null,
        randomCode: null,
        imageCode: `/static/images/checkcode.png`,
        captcha: null,
        code: null,
        bindStatus: null,
        smsMessage: "发送验证码",
        smsDisabled: false,
        timer: null,
        studentNo:null,
        phone:null
      };
    },
    beforeCreate() {
    },
    created() {
      let userInfo = JSON.parse(localStorage.getItem("userInfo"));
      this.phone=userInfo.phone;
      this.studentNo=userInfo.studentNo;
    },
    methods: {
      onChange(checked) {
        console.log(`a-switch to ${checked}`);
      },
      handleCancel() {
        this.showFlag = false;
        this.captcha = ``;
      },
      inputChange() {
        this.phoneError = "";
      },
      verificationImage() {
        var myreg = /^[1][2,3,4,5,6,7,8,9][0-9]{9}$/;
        if (!myreg.test(this.phoneNumber)) {
          this.phoneError = "手机号格式不正确！";
          return;
        } else {
          const number = parseInt(Math.random(1) * Math.pow(10, 10));
          this.randomCode = number;
          this.getRandomImage();
          this.showFlag = true;
        }
      },
      getRandomImage() {
        this.axios.get(`/sys/randomImage/${this.randomCode}`).then((res) => {
          this.imageCode = res.result;
        });
      },
      sendSms() {
        this.countdown(500);
        this.axios
          .get(`/biz/user/phone/verify/code`, {
            params: {
              captcha: this.captcha,
              checkKey: this.randomCode,
              mobile: this.phoneNumber,
            },
          })
          .then((res) => {
            if (res.success) {
              this.$message.success("发送成功");
              this.showFlag = false;
              this.countdown(500);
            }
          });
      },
      changePhone: function (phone) {
        let userInfo = JSON.parse(localStorage.getItem("userInfo"));
        console.log(userInfo);
        userInfo.phone = phone;
        console.log(phone);
        localStorage.setItem("userInfo", JSON.stringify(userInfo));
        this.changeUserInfo(userInfo);
        console.log(userInfo.phone + "test");
      },
      bindPhone() {
        this.axios
          .get(`/biz/user/phone/bind`, {
            params: {
              code: this.code,
              mobile: this.phoneNumber,
            },
          })
          .then((res) => {
            if (res.success) {
              this.$message.success("绑定成功");
              console.log(this.phoneNumber);
              let userInfo = JSON.parse(localStorage.getItem("userInfo"));
              console.log(userInfo);
              userInfo.phone =this.phoneNumber
              console.log(this.phoneNumber);
              localStorage.setItem("userInfo", JSON.stringify(userInfo));
            }
          });
      },
      ...mapMutations(['changeUserInfo']),
      // countdown(index) {
      //   console.log("执行了", index);
      //   let countdownData = index;
      //   this.smsDisabled = true;
      //   const timer = setInterval(() => {
      //     if (countdownData >= 0) {
      //       console.log("执行了", countdownData);
      //       this.smsMessage = `${countdownData}秒后重试`;
      //       countdownData--;
      //     } else {
      //       this.smsMessage = `发送验证码`;
      //       this.smsDisabled = false;
      //       clearInterval(timer);
      //     }
      //   }, 1000);
      // },
      countdown(index) {
        let countdownData = index;
        this.smsDisabled = true;

        if (this.timer) {
          clearInterval(this.timer);
        }

        this.timer = setInterval(() => {
          if (countdownData >= 0) {
            console.log("执行了", countdownData);
            this.smsMessage = `${countdownData}秒后重试`;
            countdownData--;
          } else {
            this.smsMessage = `发送验证码`;
            this.smsDisabled = false;
            clearInterval(this.timer);
          }
        }, 1000);
      },
    },
  };
</script>

<style lang="stylus" scoped>
  @import '~styles/varibles.styl';
  @import '~styles/mixins.styl';

  .content {
    background: #fff;
    margin-top: 30px;
    padding: 28px;
    color: #6c6c6c;

    .line {
      border-top: 1px solid #efefef;
    }

    .row {
      margin-bottom: 20px;

      .col-md-2 {
        margin-top: 11px;
        padding-right: 0;
      }
    }

    .explain {
      background-color: #fffbed;
      border: 1px solid #f9efd3;
      padding: 30px 30px 15px;
      line-height: 24px;
    }

    .btn-confirm {
      width: 108px;
      height: 34px;
      background: $bgColor;
      color: #fff;
    }

    .verification {
      background: #FFF1E8;
      border: 1px solid #FF751A;
      white-space: nowrap;
      padding: 6px 20px;
      min-width: 248px;
      color: #FF6A00;
      border-radius: 3px;
    }

    .tips {
      font-size: 13px;
      color: #f00;
    }
  }

  .image-random {
    display: flex;
  }

  .image-btn {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 20px 0;
  }
</style>



// WEBPACK FOOTER //
// src/pages/home/components/PhoneCheck.vue